<button (click)="action.emit()" [id]="id" class="hidden md:inline-flex" mat-button>
  <mat-icon class="fill">login</mat-icon>
  {{ 'ui.buttons.login' | transloco }}
</button>

<button
  (click)="action.emit()"
  [id]="id"
  [title]="'ui.buttons.login' | transloco"
  class="inline-flex md:hidden"
  mat-icon-button
>
  <mat-icon class="fill">login</mat-icon>
</button>
